import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';
import { getHasOpenActivity } from './getHasOpenActivity';
import { getIsAPMEnabled } from './getIsAPMEnabled';
import { getCurrentWorkOrderOp } from './getCurrentWorkOrderOp';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';
import { getIsPausedSetup } from './getIsPausedSetup';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

const getLatestJobId = createSelector(
  [
    getLatestActivitySet,
    getIsAPMEnabled,
    getHasOpenActivity,
    getCurrentWorkOrderOp,
    getPostLaborUpdatesOnNats,
    getIsPausedSetup,
    getIsApmERPJobFlow,
  ],
  (
    latestActivitySet,
    isAPMEnabled,
    hasOpenActivity,
    currentWorkOrderOp,
    natsFlowEnabled,
    isPausedSetup,
    isApmERPJobFlow
  ) => {
    // APM flow: derive job ID from the current work order op (set by opdash display)
    if (isApmERPJobFlow) {
      if (currentWorkOrderOp) {
        return `workorder-${currentWorkOrderOp.workOrderId}-${currentWorkOrderOp.sequenceNumber}`;
      }
      return null;
    }

    if (!hasOpenActivity && isAPMEnabled) {
      return null;
    }

    // NATS flow: use work order op for job ID (except for paused setup)
    if (natsFlowEnabled && !isPausedSetup && currentWorkOrderOp) {
      // Return a synthetic job ID from work order op
      // This will be used by getLatestJob to construct job info
      return `workorder-${currentWorkOrderOp.workOrderId}-${currentWorkOrderOp.sequenceNumber}`;
    }

    // Standard flow or paused setup: use activity set job ID
    return _get(latestActivitySet, 'jobId');
  }
);

export { getLatestJobId };
